define("Magento_Ui/js/lib/logger/entry-factory",["./entry"],(function(e){"use strict";return{createEntry:function(n,t,r){return new e(n,t,r)}}}));
